module.exports = __webpack_public_path__ + "static/media/about-us-image.19464ba0.png";